import { call, put } from "redux-saga/effects";
import * as API from "../../Connections/API/OrganizationAdmin";
import * as dispatchAction from "../Action/Action";


export function* getOrgsOfAdminSaga(action) {
  try {
    const response = yield call(API.getOrgsOfAdminApi, action.data);
    yield put(dispatchAction.getOrgsOfAdminSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getOrgsOfAdminFailAction(error));
  }
};


export function* setAdminSaga(action) {
  try {
    const response = yield call(API.setAdminApi, action.data);
    yield put(dispatchAction.setAdminSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.setAdminFailAction(error));
  }
};